import {
  useAddSaleProceedListMutation,
  useAddSaleProceedNotificationListMutation,
  useEditSaleProceedListMutation,
  useLazyNotificationListQuery,
  useLazySaleProceedDetailsQuery,
  useLazySaleProceedInvestmentListQuery,
  useLazySaleProceedListQuery,
  useLazySaleProceedNotificationDetailsQuery,
  useLazySaleProceedNotificationListQuery,
  useLazyTransactionReportListQuery,
  useNotificationListChangeStatusMutation,
  useSaleProceedListChangeStatusMutation,
  useSaleProceedListDeleteMutation,
  useSaleProceedListDownloadMutation,
  useSaleProceedNotificationListDownloadMutation,
} from "store/api/saleProceed";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useSaleProceedHook = () => {
  /** ***************** 
    @purpose : Used For handle get and reset data
    @Parameter : {data,reset}
    @Author : Indianic
    ***************** */
  const [
    saleProceedDetails,
    {
      data: saleProceedDetailsData,
      isUninitialized: isSaleProceedDetailsUninitialized,
    },
  ] = useLazySaleProceedDetailsQuery();

  const [
    saleProceedList,
    {
      data: saleProceedListData,
      isUninitialized: isSaleProceedListUninitialized,
    },
  ] = useLazySaleProceedListQuery({
    fixedCacheKey: fixedCacheKeys.SALE_PROCEED_LIST,
  });

  const [
    saleProceedInvestmentList,
    {
      data: saleProceedInvestmentListData,
      isUninitialized: isSaleProceedInvestmentListUninitialized,
    },
  ] = useLazySaleProceedInvestmentListQuery({
    fixedCacheKey: fixedCacheKeys.SALE_PROCEED_INVESTMENT_LIST,
  });

  const [
    saleProceedListChangeStatus,
    { isLoading: saleProceedListChangeStatusLoader },
  ] = useSaleProceedListChangeStatusMutation({
    fixedCacheKey: fixedCacheKeys.SALE_PROCEED_LIST_CHANGE_STATUS,
  });

  const [editSaleProceedList] = useEditSaleProceedListMutation({
    fixedCacheKey: fixedCacheKeys.EDIT_SALE_PROCEED_LIST,
  });

  const [saleProceedListDelete] = useSaleProceedListDeleteMutation({
    fixedCacheKey: fixedCacheKeys.SALE_PROCEED_LIST_DELETE,
  });

  const [addSaleProceedList, { isLoading: addSaleProceedListLoader }] =
    useAddSaleProceedListMutation({
      fixedCacheKey: fixedCacheKeys.ADD_SALE_PROCEED_LIST,
    });

  const [
    addSaleProceedNotificationList,
    { isLoading: addSaleProceedNotificationListLoader },
  ] = useAddSaleProceedNotificationListMutation({
    fixedCacheKey: fixedCacheKeys.ADD_SALE_PROCEED_NOTIFICATION_LIST,
  });

  const [
    transactionReport,
    {
      data: transactionReportData,
      isUninitialized: isTransactionReportUninitialized,
    },
  ] = useLazyTransactionReportListQuery({
    fixedCacheKey: fixedCacheKeys.TRANSACTION_REPORT,
  });

  const [
    saleProceedNotificationDetails,
    {
      data: saleProceedNotificationDetailsData,
      isUninitialized: isSaleProceedNotificationDetailsUninitialized,
    },
  ] = useLazySaleProceedNotificationDetailsQuery({
    fixedCacheKey: fixedCacheKeys.SALE_PROCEED_NOTIFICATION_DETAILS,
  });

  const [
    NotificationList,
    {
      data: NotificationListData,
      isUninitialized: isNotificationListUninitialized,
    },
  ] = useLazyNotificationListQuery({
    fixedCacheKey: fixedCacheKeys.NOTIFICATIONS,
  });

  const [
    NotificationListChangeStatus,
    { isLoading: NotificationListChangeStatusLoader },
  ] = useNotificationListChangeStatusMutation({
    fixedCacheKey: fixedCacheKeys.NOTIFICATIONS,
  });

  const [
    saleProceedNotificationList,
    {
      data: saleProceedNotificationListData,
      isUninitialized: isSaleProceedNotificationListUninitialized,
    },
  ] = useLazySaleProceedNotificationListQuery({
    fixedCacheKey: fixedCacheKeys.SALE_PROCEED_NOTIFICATION_LIST,
  });

  const [saleProceedListDownload] = useSaleProceedListDownloadMutation({
    fixedCacheKey: fixedCacheKeys.SALE_PROCEED_LIST_DOWNLOAD,
  });

  const [saleProceedNotificationListDownload] =
    useSaleProceedNotificationListDownloadMutation({
      fixedCacheKey: fixedCacheKeys.SALE_PROCEED_NOTIFICATION_LIST_DOWNLOAD,
    });

  return {
    saleProceedList,
    saleProceedListData,
    saleProceedListChangeStatus,
    saleProceedListDelete,
    addSaleProceedList,
    addSaleProceedListLoader,
    isSaleProceedListUninitialized,
    saleProceedDetails,
    editSaleProceedList,
    saleProceedListChangeStatusLoader,
    saleProceedDetailsData,
    isSaleProceedDetailsUninitialized,
    saleProceedInvestmentList,
    saleProceedInvestmentListData,
    isSaleProceedInvestmentListUninitialized,
    transactionReport,
    transactionReportData,
    isTransactionReportUninitialized,
    saleProceedNotificationDetails,
    saleProceedNotificationDetailsData,
    isSaleProceedNotificationDetailsUninitialized,
    saleProceedNotificationList,
    saleProceedNotificationListData,
    isSaleProceedNotificationListUninitialized,
    addSaleProceedNotificationList,
    addSaleProceedNotificationListLoader,
    NotificationList,
    NotificationListData,
    isNotificationListUninitialized,
    NotificationListChangeStatus,
    NotificationListChangeStatusLoader,
    saleProceedListDownload,
    saleProceedNotificationListDownload,
  };
};
